export const vaccinesByRegion = {
  USAFRICOM: [
    {
      name: 'Typhoid',
      administration:
        'Schedule: Injectable: every 2 yr; Oral: every 5 yr\n                Route: Intramuscular or Oral\n                Dose: IM 0.5ml; Oral, 4 capsules (day 1,3,5,7)',
      required: 'Required.',
    },
    {
      name: 'Tdap',
      administration:
        'Schedule: 1 lifetime dose of Tdap, Td boosters every 10 yrs. For adults who previously have not received a dose of Tdap, 1 dose should be given regardless of interval since last tetanus vaccine.\n                Route: Intramuscular (Tdap, Td, Tetanus Toxoid)\n                Dose: 0.5ml (Tdap, Td, Tetanus Toxoid)',
      required: 'Required.',
    },
    {
      name: 'Meningococcal',
      administration:
        'Schedule: If at prolonged risk of disease exposure, vaccinate every 5 yrs.\n                Route: Menomune, Subcutaneous; Menactra and Menveo, Intramuscular \n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'M-M-R',
      administration:
        'Schedule: 2 lifetime doses or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'Influenza - Seasonal',
      administration:
        'Schedule: 1 dose annually\n                Route: Intramuscular, Intranasal\n                Dose: IM 0.5ml; Intranasal 0.2ml',
      required: 'Required.',
    },
    {
      name: 'Hepatitis B',
      administration:
        'Schedule: Engerix-B, Recombivax, Twinrix: 0,1,6m (3 dose)or Heplisav-B: 0,1m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: Engerix-B or Recombivax: 0-19 years, 0.5ml; >=20 years, 1 ml; Twinrix >=18 years, 1ml; Heplisav-B >=18 years, 0.5mL',
      required: 'Required.',
    },
    {
      name: 'Hepatitis A',
      administration:
        'Schedule: 0, 6m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: 1-18 years, 0.5ml; >=19 years, 1 ml; Twinrix >=18 years, 1ml',
      required: 'Required.',
    },
    {
      name: 'Chickenpox',
      administration:
        'Schedule: 0, 4-8w (2 dose) or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'Pneumococcal',
      administration:
        'Schedule: High risk: 1 dose, Asplenic Only: 1 dose + 1 time booster if 5 yrs or greater since 1st dose\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required: 'Required for high risk health conditions per ACIP.',
    },
    {
      name: 'Polio',
      administration:
        'Schedule: 1 dose as adult\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required:
        'Required. See additional guidance for travel to and from USAFRICOM countries affected by polio. See also Interim CDC Guidance for Travel to high risk countries.',
    },
    {
      name: 'Rabies',
      administration:
        'Schedule: Pre-Exposure: 0,7,(21 or 28d) Booster: 2-5 yr (when titer drops >1:5)\n                Route: Intramuscular\n                Dose: 1ml',
      required: 'Required for personnel at high risk for exposure IAW Service-Specific guidelines.',
    },
    {
      name: 'Yellow Fever',
      administration:
        'Schedule: 1 lifetime dose. Must be administered 10 days prior to travel.\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required:
        'Required except for Comoros, Morocco and Tunisia. All YF vaccinations must be documented on a CDC 731. See exception for Ascension Island.',
    },
  ],
  USCENTCOM: [
    {
      name: 'Typhoid',
      administration:
        'Schedule: Injectable: every 2 yr; Oral: every 5 yr\n                Route: Intramuscular or Oral\n                Dose: IM 0.5ml; Oral, 4 capsules (day 1,3,5,7)',
      required: 'Required.',
    },
    {
      name: 'Tdap',
      administration:
        'Schedule: 1 lifetime dose of Tdap, Td boosters every 10 yrs. For adults who previously have not received a dose of Tdap, 1 dose should be given regardless of interval since last tetanus vaccine.\n                Route: Intramuscular (Tdap, Td, Tetanus Toxoid)\n                Dose: 0.5ml (Tdap, Td, Tetanus Toxoid)',
      required: 'Required.',
    },
    {
      name: 'Influenza - Seasonal',
      administration:
        'Schedule: 1 dose annually\n                Route: Intramuscular, Intranasal\n                Dose: IM 0.5ml; Intranasal 0.2ml',
      required: 'Required.',
    },
    {
      name: 'Hepatitis B',
      administration:
        'Schedule: Engerix-B, Recombivax, Twinrix: 0,1,6m (3 dose)or Heplisav-B: 0,1m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: Engerix-B or Recombivax: 0-19 years, 0.5ml; >=20 years, 1 ml; Twinrix >=18 years, 1ml; Heplisav-B >=18 years, 0.5mL',
      required: 'Required.',
    },
    {
      name: 'Hepatitis A',
      administration:
        'Schedule: 0, 6m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: 1-18 years, 0.5ml; >=19 years, 1 ml; Twinrix >=18 years, 1ml',
      required: 'Required.',
    },
    {
      name: 'Anthrax',
      administration:
        'Schedule: 0,4w,6,12,18m + annual booster\n                Route: Intramuscular\n                Dose: 0.5ml',
      required: 'Required for 15 or more days in theater.',
    },
    {
      name: 'Chickenpox',
      administration:
        'Schedule: 0, 4-8w (2 dose) or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required:
        'Required. Documentation must include one of the following: Born before 1980, history of disease, sufficient varicella titer, or administration of vaccine.',
    },
    {
      name: 'M-M-R',
      administration:
        'Schedule: 2 lifetime doses or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required:
        'Required. Documentation must include one of the following: Born before 1957, effective immunity by titer, or administration of two lifetime doses.',
    },
    {
      name: 'Pneumococcal',
      administration:
        'Schedule: High risk: 1 dose, Asplenic Only: 1 dose + 1 time booster if 5 yrs or greater since 1st dose\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required: 'Required for high risk health conditions per ACIP.',
    },
    {
      name: 'Polio',
      administration:
        'Schedule: 1 dose as adult\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required:
        'For individuals traveling for > 4 weeks, vaccination required to be administered within 12 months of DEPARTURE FROM Afghanistan and Pakistan.',
    },
    {
      name: 'Rabies',
      administration:
        'Schedule: Pre-Exposure: 0,7,(21 or 28d) Booster: 2-5 yr (when titer drops >1:5)\n                Route: Intramuscular\n                Dose: 1ml',
      required: 'Required for personnel at high risk for exposure IAW Service-Specific guidelines.',
    },
  ],
  USEUCOM: [
    {
      name: 'Tdap',
      administration:
        'Schedule: 1 lifetime dose of Tdap, Td boosters every 10 yrs. For adults who previously have not received a dose of Tdap, 1 dose should be given regardless of interval since last tetanus vaccine.\n                Route: Intramuscular (Tdap, Td, Tetanus Toxoid)\n                Dose: 0.5ml (Tdap, Td, Tetanus Toxoid)',
      required: 'Required.',
    },
    {
      name: 'Polio',
      administration:
        'Schedule: 1 dose as adult\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'M-M-R',
      administration:
        'Schedule: 2 lifetime doses or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'Influenza - Seasonal',
      administration:
        'Schedule: 1 dose annually\n                Route: Intramuscular, Intranasal\n                Dose: IM 0.5ml; Intranasal 0.2ml',
      required: 'Required.',
    },
    {
      name: 'Hepatitis B',
      administration:
        'Schedule: Engerix-B, Recombivax, Twinrix: 0,1,6m (3 dose)or Heplisav-B: 0,1m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: Engerix-B or Recombivax: 0-19 years, 0.5ml; >=20 years, 1 ml; Twinrix >=18 years, 1ml; Heplisav-B >=18 years, 0.5mL',
      required: 'Required.',
    },
    {
      name: 'Hepatitis A',
      administration:
        'Schedule: 0, 6m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: 1-18 years, 0.5ml; >=19 years, 1 ml; Twinrix >=18 years, 1ml',
      required: 'Required.',
    },
    {
      name: 'Chickenpox',
      administration:
        'Schedule: 0, 4-8w (2 dose) or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'Meningococcal',
      administration:
        'Schedule: If at prolonged risk of disease exposure, vaccinate every 5 yrs.\n                Route: Menomune, Subcutaneous; Menactra and Menveo, Intramuscular \n                Dose: 0.5ml',
      required: 'Specific countries only - See NCMI recommendations.',
    },
    {
      name: 'Pneumococcal',
      administration:
        'Schedule: High risk: 1 dose, Asplenic Only: 1 dose + 1 time booster if 5 yrs or greater since 1st dose\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required: 'Required for high risk health conditions per ACIP.',
    },
    {
      name: 'Rabies',
      administration:
        'Schedule: Pre-Exposure: 0,7,(21 or 28d) Booster: 2-5 yr (when titer drops >1:5)\n                Route: Intramuscular\n                Dose: 1ml',
      required: 'Required for personnel at high risk for exposure IAW Service-Specific guidelines.',
    },
    {
      name: 'Typhoid',
      administration:
        'Schedule: Injectable: every 2 yr; Oral: every 5 yr\n                Route: Intramuscular or Oral\n                Dose: IM 0.5ml; Oral, 4 capsules (day 1,3,5,7)',
      required:
        'Required for countries with intermediate or high risk per NCMI, to include: Albania, Georgia, Israel, Kosovo, Macedonia, Moldova, Montenegro, Romania, Russia, Serbia, Turkey and Ukraine.',
    },
    {
      name: 'Yellow Fever',
      administration:
        'Schedule: 1 lifetime dose. Must be administered 10 days prior to travel.\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Specific countries only - See YF vaccine transiting requirements.',
    },
  ],
  USINDOPACOM: [
    {
      name: 'Tdap',
      administration:
        'Schedule: 1 lifetime dose of Tdap, Td boosters every 10 yrs. For adults who previously have not received a dose of Tdap, 1 dose should be given regardless of interval since last tetanus vaccine.\n                Route: Intramuscular (Tdap, Td, Tetanus Toxoid)\n                Dose: 0.5ml (Tdap, Td, Tetanus Toxoid)',
      required: 'Required.',
    },
    {
      name: 'M-M-R',
      administration:
        'Schedule: 2 lifetime doses or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'Hepatitis B',
      administration:
        'Schedule: Engerix-B, Recombivax, Twinrix: 0,1,6m (3 dose)or Heplisav-B: 0,1m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: Engerix-B or Recombivax: 0-19 years, 0.5ml; >=20 years, 1 ml; Twinrix >=18 years, 1ml; Heplisav-B >=18 years, 0.5mL',
      required: 'Required.',
    },
    {
      name: 'Hepatitis A',
      administration:
        'Schedule: 0, 6m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: 1-18 years, 0.5ml; >=19 years, 1 ml; Twinrix >=18 years, 1ml',
      required: 'Required.',
    },
    {
      name: 'Chickenpox',
      administration:
        'Schedule: 0, 4-8w (2 dose) or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'Anthrax',
      administration:
        'Schedule: 0,4w,6,12,18m + annual booster\n                Route: Intramuscular\n                Dose: 0.5ml',
      required:
        'Required for travel of 15 days or longer to Korea, to include forward deployed Naval forces. Required for III MEF. All others per DoD policy.',
    },
    {
      name: 'Influenza, Northern Hemisphere (NH)',
      administration:
        'Schedule: 1 dose annually\n                Route: Intramuscular, Intranasal\n                Dose: IM 0.5ml; Intranasal 0.2ml',
      required:
        'Required if you are residing in / traveling to a designated NH vaccine country by the WHO for 14 or more days from October through March.',
    },
    {
      name: 'Influenza, Southern Hemisphere (SH)',
      administration:
        'Schedule: 1 dose annually\n                Route: Intramuscular\n                Dose: IM 0.5ml',
      required:
        'Required if you are residing in / traveling to a designated SH vaccine country by the WHO for 14 or more days from April through September.',
    },
    {
      name: 'Japanese encephalitis',
      administration:
        'Schedule: 0,28 d (2 dose). One-time booster dose if >11 months after series complete and still in endemic area.\n                Route: Intramuscular\n                Dose: 0.5ml',
      required:
        'Required for the following countries and groups: Korea, SOF and III MEF. Required in Japan for PACFLT and USAF in addition to those previously listed. Recommended for all others.',
    },
    {
      name: 'Pneumococcal',
      administration:
        'Schedule: High risk: 1 dose, Asplenic Only: 1 dose + 1 time booster if 5 yrs or greater since 1st dose\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required: 'Required for high risk health conditions per ACIP.',
    },
    {
      name: 'Polio',
      administration:
        'Schedule: 1 dose as adult\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required:
        'Required. In the setting of a polio outbreak, comply with CDC or WHO recommendations and if in-country deployment is > 4 weeks, vaccination is required prior to arriving in country.',
    },
    {
      name: 'Rabies',
      administration:
        'Schedule: Pre-Exposure: 0,7,(21 or 28d) Booster: 2-5 yr (when titer drops >1:5)\n                Route: Intramuscular\n                Dose: 1ml',
      required: 'Required for personnel at high risk for exposure IAW Service-Specific guidelines',
    },
    {
      name: 'Smallpox',
      administration:
        'Schedule: 1 dose, every 10 yr\n                Route: 15 percutaneous jabs for primary and re-vaccinees, over deltoid.',
      required:
        'Required for travel of 15 days or longer to Korea, to include forward deployed naval forces. Required for III MEF. All others per DoD policy.',
    },
    {
      name: 'Typhoid',
      administration:
        'Schedule: Injectable: every 2 yr; Oral: every 5 yr\n                Route: Intramuscular or Oral\n                Dose: IM 0.5ml; Oral, 4 capsules (day 1,3,5,7)',
      required: 'Required for Korea, III MEF and Operational Forces. All others per DoD policy.',
    },
    {
      name: 'Yellow Fever',
      administration:
        'Schedule: 1 lifetime dose. Must be administered 10 days prior to travel.\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required:
        'Required only for entry into some USINDOPACOM countries (per CDC Yellow Book) if traveling from, or transiting through, endemic areas (Africa & South America). CDC 731 Stamp required.',
    },
  ],
  USNORTHCOM: [
    {
      name: 'Tdap',
      administration:
        'Schedule: 1 lifetime dose of Tdap, Td boosters every 10 yrs. For adults who previously have not received a dose of Tdap, 1 dose should be given regardless of interval since last tetanus vaccine.\n                Route: Intramuscular (Tdap, Td, Tetanus Toxoid)\n                Dose: 0.5ml (Tdap, Td, Tetanus Toxoid)',
      required: 'Required.',
    },
    {
      name: 'Polio',
      administration:
        'Schedule: 1 dose as adult\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'M-M-R',
      administration:
        'Schedule: 2 lifetime doses or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'Influenza - Seasonal',
      administration:
        'Schedule: 1 dose annually\n                Route: Intramuscular, Intranasal\n                Dose: IM 0.5ml; Intranasal 0.2ml',
      required: 'Required.',
    },
    {
      name: 'Hepatitis A',
      administration:
        'Schedule: 0, 6m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: 1-18 years, 0.5ml; >=19 years, 1 ml; Twinrix >=18 years, 1ml',
      required: 'Required.',
    },
    {
      name: 'Chickenpox',
      administration:
        'Schedule: 0, 4-8w (2 dose) or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'Anthrax',
      administration:
        'Schedule: 0,4w,6,12,18m + annual booster\n                Route: Intramuscular\n                Dose: 0.5ml',
      required: 'Per DoD Policy.',
    },
    {
      name: 'Hepatitis B',
      administration:
        'Schedule: Engerix-B, Recombivax, Twinrix: 0,1,6m (3 dose)or Heplisav-B: 0,1m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: Engerix-B or Recombivax: 0-19 years, 0.5ml; >=20 years, 1 ml; Twinrix >=18 years, 1ml; Heplisav-B >=18 years, 0.5mL',
      required: 'Per DoD Policy.',
    },
    {
      name: 'Meningococcal',
      administration:
        'Schedule: If at prolonged risk of disease exposure, vaccinate every 5 yrs.\n                Route: Menomune, Subcutaneous; Menactra and Menveo, Intramuscular \n                Dose: 0.5ml',
      required: 'N/A',
    },
    {
      name: 'Pneumococcal',
      administration:
        'Schedule: High risk: 1 dose, Asplenic Only: 1 dose + 1 time booster if 5 yrs or greater since 1st dose\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required: 'Required for high risk health conditions per ACIP.',
    },
    {
      name: 'Rabies',
      administration:
        'Schedule: Pre-Exposure: 0,7,(21 or 28d) Booster: 2-5 yr (when titer drops >1:5)\n                Route: Intramuscular\n                Dose: 1ml',
      required: 'Required for personnel at high risk for exposure IAW Service-Specific guidelines',
    },
    {
      name: 'Smallpox',
      administration:
        'Schedule: 1 dose, every 10 yr\n                Route: 15 percutaneous jabs for primary and re-vaccinees, over deltoid.',
      required: 'Per DoD Policy.',
    },
    {
      name: 'Typhoid',
      administration:
        'Schedule: Injectable: every 2 yr; Oral: every 5 yr\n                Route: Intramuscular or Oral\n                Dose: IM 0.5ml; Oral, 4 capsules (day 1,3,5,7)',
      required: 'Per NORAD & USNORTHCOM Instruction 44-163.',
    },
  ],
  USSOUTHCOM: [
    {
      name: 'Typhoid',
      administration:
        'Schedule: Injectable: every 2 yr; Oral: every 5 yr\n                Route: Intramuscular or Oral\n                Dose: IM 0.5ml; Oral, 4 capsules (day 1,3,5,7)',
      required: 'Required.',
    },
    {
      name: 'Tdap',
      administration:
        'Schedule: 1 lifetime dose of Tdap, Td boosters every 10 yrs. For adults who previously have not received a dose of Tdap, 1 dose should be given regardless of interval since last tetanus vaccine.\n                Route: Intramuscular (Tdap, Td, Tetanus Toxoid)\n                Dose: 0.5ml (Tdap, Td, Tetanus Toxoid)',
      required: 'Required.',
    },
    {
      name: 'Polio',
      administration:
        'Schedule: 1 dose as adult\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'M-M-R',
      administration:
        'Schedule: 2 lifetime doses or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'Influenza - Seasonal',
      administration:
        'Schedule: 1 dose annually\n                Route: Intramuscular, Intranasal\n                Dose: IM 0.5ml; Intranasal 0.2ml',
      required: 'Required.',
    },
    {
      name: 'Hepatitis B',
      administration:
        'Schedule: Engerix-B, Recombivax, Twinrix: 0,1,6m (3 dose)or Heplisav-B: 0,1m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: Engerix-B or Recombivax: 0-19 years, 0.5ml; >=20 years, 1 ml; Twinrix >=18 years, 1ml; Heplisav-B >=18 years, 0.5mL',
      required: 'Required.',
    },
    {
      name: 'Hepatitis A',
      administration:
        'Schedule: 0, 6m (2 dose) or + serologic testing\n                Route: Intramuscular\n                Dose: 1-18 years, 0.5ml; >=19 years, 1 ml; Twinrix >=18 years, 1ml',
      required: 'Required.',
    },
    {
      name: 'Chickenpox',
      administration:
        'Schedule: 0, 4-8w (2 dose) or + serologic testing\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required: 'Required.',
    },
    {
      name: 'Pneumococcal',
      administration:
        'Schedule: High risk: 1 dose, Asplenic Only: 1 dose + 1 time booster if 5 yrs or greater since 1st dose\n                Route: Subcutaneous or Intramuscular\n                Dose: 0.5ml',
      required: 'Required for high risk health conditions per ACIP.',
    },
    {
      name: 'Rabies',
      administration:
        'Schedule: Pre-Exposure: 0,7,(21 or 28d) Booster: 2-5 yr (when titer drops >1:5)\n                Route: Intramuscular\n                Dose: 1ml',
      required: 'Required for personnel at high risk for exposure IAW Service-Specific guidelines.',
    },
    {
      name: 'Yellow Fever',
      administration:
        'Schedule: 1 lifetime dose. Must be administered 10 days prior to travel.\n                Route: Subcutaneous\n                Dose: 0.5ml',
      required:
        'Required for countries where the disease is endemic, per the CDC.\n            Required if traveling from an endemic area to those countries with transiting requirements (per WHO) and per USSOUTHCOM memo dated November 28, 2018.',
    },
  ],
};

export const allVaccines = [
  'Covid-19 Shot 1',
  'Covid-19 Shot 2',
  'Typhoid',
  'Tdap',
  'Meningococcal',
  'M-M-R',
  'Influenza - Seasonal',
  'Hepatitis B',
  'Hepatitis A',
  'Chickenpox',
  'Pneumococcal',
  'Polio',
  'Rabies',
  'Yellow Fever',
  'Anthrax',
  'Influenza, Northern Hemisphere (NH)',
  'Influenza, Southern Hemisphere (SH)',
  'Japanese encephalitis',
  'Smallpox',
];
